module.exports = __webpack_public_path__ + "static/HF-16e5856b4326be80ba47f24019cc667f.jpg";